<template>
  <base-spinner :open="isloading"></base-spinner>
  <base-message
  v-if="!isloading"
  :servermessages="servermessages"
  ></base-message>
  <div class="site__body">
    <div class="block-space block-space--layout--after-header"></div>
    <div class="block">
      <div class="container container--max--xl">
        <div class="row">
          <account-navigation active-page="account-garage"></account-navigation>
          <div class="col-12 col-lg-9 mt-4 mt-lg-0">
            <div class="card">
              <div class="card-header">
                <h5>Your Saved Vehicles</h5>
              </div>
              <div class="card-divider"></div>
              <div class="card-body card-body--padding--2">
                <saved-vehicle-list :vehiclelist="vehiclelist" @confirm-remove="confirmRemove"></saved-vehicle-list>
              </div>
              <div class="card-divider"></div>
              <div class="card-header">
                <h5>Add a Vehicle</h5>
              </div>
              <div class="card-divider"></div>
              <add-vehicle @added-vehicle="addedVehicle"></add-vehicle>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-space block-space--layout--before-footer"></div>
  </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import AccountNavigation from "../accountnavigation/AccountNavigation";
import SavedVehicleList from "./SavedVehicleList";
import AddVehicle from "./AddVehicle";
import { mapGetters } from 'vuex';

export default {
  name: "AccountGarage",
  components: {
    "account-navigation": AccountNavigation,
    "saved-vehicle-list": SavedVehicleList,
    "add-vehicle": AddVehicle,
  },
  data() {
    return {
      vehiclelist: [],
      isloading: false,
      servermessages: []
    }
  },
  computed: {
    ...mapGetters([
        "appInitialiazed"
    ]),
  },
  watch: {
    appInitialiazed(newVal) {
      if(newVal == true){
          this.getSavedVehicles();
      }
    }
  },
  methods: {
    getSavedVehicles() {
      this.isloading = true;
      this.vehiclelist = [];
      const catpn = this.$store.getters['storeConfigID'];
      axiosvl.post(this.$store.getters['api/get_saved_vehicle_uri'], {
          "webroutine": {
            "context": {
                "session-key-method": "hidden"
            },
            "fields": {
                "EHCUST": {"value": this.$store.getters.customer},
                "CATPN": {"value": catpn},
            }
          }
      })
      .then((response) => {
          const fields = response.data.webroutine.fields
          const messages = [];

          if (fields.RESULTCOD.value === 'OK') {
            const results = [];

            for (const key in response.data.webroutine.lists.LASTCARSD.entries) {
              const obj = response.data.webroutine.lists.LASTCARSD.entries[key];
              results.push({
                year: obj.QYEAR,
                make: obj.QMAKE,
                makedesc: obj.QMKDSC,
                model: obj.QMODEL,
                modeldesc: obj.QMODSC,
                engine: obj.QCARCD,
                enginedesc: obj.QENDSC,
              });
            }
            this.vehiclelist = results;
          } else {
            const wrmessages = response.data.webroutine.messages;

            for (var i = 0; i < wrmessages.length; i++) {
              messages.push(wrmessages[i]);
            }

            // Return code is not "OK" but no messages appear, add a custom error message
            if (messages.length === 0) {
              messages.push("Something went wrong. Please try again later.");
            }
          }

          this.isloading = false;
          this.servermessages = messages;
      })
      .catch((error) => {
        this.isloading = false;
          console.error("error - " + error);
      });
    },
    confirmRemove(index) {
      alert('No delete web service exists yet. Index: ' + index);
    },
    addedVehicle() {
      this.getSavedVehicles();
    }
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });

    if(this.appInitialiazed == true){
      this.getSavedVehicles();
    }
    
  }
};
</script>